import { useEffect, useState } from "react";
import { request } from "../../../network/Request";
import { findCountryFlag } from "./countries";

const TeamTable = ({ distance, targetType }) => {
  const [teamMemberArray, setTeamMemberArray] = useState([]);

  // 등수 계산 함수 (동점 처리)
  const calculateRank = (teams) => {
    let currentRank = 1;

    return teams.map((team, index) => {
      if (index > 0 && team.total !== teams[index - 1].total) {
        currentRank = index + 1;
      }
      return {
        ...team,
        rank: currentRank,
      };
    });
  };

  useEffect(() => {
    request({
      "bk-working": "team-score-list",
      "distance": distance,
      "target_type": targetType
    }).then(({result, response}) => {
      if (result) {
        console.log(response);
        let teamScores = response["team_score_list"];
        console.log(teamScores);

        // 팀별로 그룹화
        const teamGroups = {};

        teamScores.forEach((player) => {
          const teamName = player.team_name;
          if (!teamGroups[teamName]) {
            teamGroups[teamName] = {
              team_name: teamName,
              country: player.country,
              players: [],
            };
          }

          teamGroups[teamName].players.push({
            player_name: player.player_name,
            score: player.score || 0,
            target_join_id: player.target_join_id,
          });
        });

        // 팀별 총점 계산 및 배열 변환
        const teams = Object.values(teamGroups).map((team) => {
          // 총점 계산
          const total = team.players.reduce(
            (sum, player) => sum + player.score,
            0
          );

          // 5명 초과 여부 확인
          const hasMoreThan5 = team.length > 5;
          if (hasMoreThan5) {
            console.warn(`⚠️ ${teams.team_name} 팀은 ${teams.length}명입니다.`);
          } else {
            console.log(`팀 정상`);
          }

          return {
            ...team,
            total: total,
          };
        });

        // 팀 총점으로 내림차순 정렬
        teams.sort((a, b) => b.total - a.total);

        // 등수 계산
        const withRank = calculateRank(teams);

        setTeamMemberArray(withRank);
      }
    });
  }, [distance, targetType]);

  return (
    <>
      <div className="table-box box-1 margin-table">
        <div className="table-wrap">
          <div className="table-shadow">
            <table>
              <colgroup>
                <col width="5%" />
                <col width="5%" />
              </colgroup>
              <thead>
                <tr>
                  <th rowSpan="2">Rank</th>
                  <th rowSpan="2">Country</th>
                  <th rowSpan="2">Team Name</th>
                  <th colSpan="5">Individual Score</th>
                  <th rowSpan="2">Total</th>
                </tr>
                <tr>
                  <th>Player 1</th>
                  <th>Player 2</th>
                  <th>Player 3</th>
                  <th>Player 4</th>
                  <th>Player 5</th>
                </tr>
              </thead>
              <tbody>
                {teamMemberArray.map((team, index) => (
                  <tr className={index < 3 ? "ranking" : ""} key={index}>
                    <td>{index + 1}</td>
                    <td>{team.country}</td>
                    <td>{team.team_name}</td>
                    {/* 선수 1~5의 점수 표시 */}
                    {[0, 1, 2, 3, 4].map((playerIndex) => (
                      <td key={playerIndex}>
                        {team.players[playerIndex] ? (
                          <>
                            {team.players[playerIndex].score}
                            <br />({team.players[playerIndex].player_name})
                          </>
                        ) : (
                          "-"
                        )}
                      </td>
                    ))}
                    <td className="sum">{team.total}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="table-gradient"></div>
        </div>
      </div>
    </>
  );
};
export default TeamTable;
